function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Details",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "datensatz_objekt_texte",
  transform: "translate(-965.000000, -279.000000)",
  fill: "#0B4A98"
}, /*#__PURE__*/React.createElement("path", {
  d: "M979.394601,284.462563 C979.760855,284.462563 980.126209,284.600252 980.403375,284.87743 C980.956805,285.430886 980.956805,286.344312 980.403375,286.898668 L974.343532,292.958783 C973.789201,293.513139 972.875816,293.513139 972.322385,292.958783 L969.629021,290.264399 C969.075591,289.710943 969.075591,288.798416 969.629021,288.24496 C970.183352,287.690605 971.094938,287.690605 971.649269,288.24496 L973.332058,289.928726 L978.384027,284.87743 C978.661192,284.600252 979.028346,284.462563 979.394601,284.462563 M974.99865,279 C969.48144,279 965,283.483441 965,289.0009 C965,294.518359 969.48144,299 974.99865,299 C980.515861,299 985,294.518359 985,289.0009 C985,283.483441 980.515861,279 974.99865,279",
  id: "Fill-1"
})));

var SvgIconCheckWithBackground = function SvgIconCheckWithBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckWithBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-check-with-background.d06b4a31.svg";
export { ForwardRef as ReactComponent };